"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vehicle = void 0;
var Vehicle;
(function (Vehicle) {
    let DealEnum;
    (function (DealEnum) {
        DealEnum[DealEnum["Great"] = 1] = "Great";
        DealEnum[DealEnum["Good"] = 2] = "Good";
        DealEnum[DealEnum["Fair"] = 3] = "Fair";
        DealEnum[DealEnum["Bad"] = 4] = "Bad";
        DealEnum[DealEnum["Low"] = 0] = "Low";
    })(DealEnum = Vehicle.DealEnum || (Vehicle.DealEnum = {}));
    let BodyTypeEnum;
    (function (BodyTypeEnum) {
        BodyTypeEnum[BodyTypeEnum["Pickup"] = 1] = "Pickup";
        BodyTypeEnum[BodyTypeEnum["CrewCab"] = 1.1] = "CrewCab";
        BodyTypeEnum[BodyTypeEnum["ExtendedCab"] = 1.2] = "ExtendedCab";
        BodyTypeEnum[BodyTypeEnum["RegularCab"] = 1.3] = "RegularCab";
        BodyTypeEnum[BodyTypeEnum["SUVCrossover"] = 2] = "SUVCrossover";
        BodyTypeEnum[BodyTypeEnum["Car"] = 3] = "Car";
        BodyTypeEnum[BodyTypeEnum["Sedan"] = 3.1] = "Sedan";
        BodyTypeEnum[BodyTypeEnum["Coupe"] = 3.2] = "Coupe";
        BodyTypeEnum[BodyTypeEnum["Hatchback"] = 3.3] = "Hatchback";
        BodyTypeEnum[BodyTypeEnum["Wagon"] = 3.4] = "Wagon";
        BodyTypeEnum[BodyTypeEnum["Van"] = 4] = "Van";
        BodyTypeEnum[BodyTypeEnum["MiniVan"] = 4.1] = "MiniVan";
        BodyTypeEnum[BodyTypeEnum["FullSizeVan"] = 4.2] = "FullSizeVan";
        BodyTypeEnum[BodyTypeEnum["PassengerVan"] = 4.3] = "PassengerVan";
        BodyTypeEnum[BodyTypeEnum["CargoVan"] = 4.4] = "CargoVan";
        BodyTypeEnum[BodyTypeEnum["Convertible"] = 5] = "Convertible";
        BodyTypeEnum[BodyTypeEnum["Chassis"] = 6] = "Chassis";
        BodyTypeEnum[BodyTypeEnum["SemiTrailerTruck"] = 7] = "SemiTrailerTruck";
        BodyTypeEnum[BodyTypeEnum["Truck"] = 8] = "Truck";
        BodyTypeEnum[BodyTypeEnum["Bus"] = 9] = "Bus";
    })(BodyTypeEnum = Vehicle.BodyTypeEnum || (Vehicle.BodyTypeEnum = {}));
    let TitleTypeEnum;
    (function (TitleTypeEnum) {
        TitleTypeEnum[TitleTypeEnum["Clear"] = 1] = "Clear";
        TitleTypeEnum[TitleTypeEnum["Salvage"] = 2] = "Salvage";
        TitleTypeEnum[TitleTypeEnum["Rebuilt"] = 3] = "Rebuilt";
        TitleTypeEnum[TitleTypeEnum["Lemon"] = 4] = "Lemon";
        TitleTypeEnum[TitleTypeEnum["Flood"] = 5] = "Flood";
    })(TitleTypeEnum = Vehicle.TitleTypeEnum || (Vehicle.TitleTypeEnum = {}));
    let SellerTypeEnum;
    (function (SellerTypeEnum) {
        SellerTypeEnum[SellerTypeEnum["Private"] = 1] = "Private";
        SellerTypeEnum[SellerTypeEnum["Dealer"] = 2] = "Dealer";
    })(SellerTypeEnum = Vehicle.SellerTypeEnum || (Vehicle.SellerTypeEnum = {}));
    let SaleStatusEnum;
    (function (SaleStatusEnum) {
        SaleStatusEnum[SaleStatusEnum["Any"] = 0] = "Any";
        SaleStatusEnum[SaleStatusEnum["Sold"] = -1] = "Sold";
        SaleStatusEnum[SaleStatusEnum["OpenToOffers"] = 1] = "OpenToOffers";
        SaleStatusEnum[SaleStatusEnum["ForSale"] = 2] = "ForSale";
        SaleStatusEnum[SaleStatusEnum["NotForSale"] = 3] = "NotForSale";
    })(SaleStatusEnum = Vehicle.SaleStatusEnum || (Vehicle.SaleStatusEnum = {}));
    let CountryEnum;
    (function (CountryEnum) {
        CountryEnum[CountryEnum["US"] = 1] = "US";
        CountryEnum[CountryEnum["CA"] = 2] = "CA";
        CountryEnum[CountryEnum["MX"] = 3] = "MX";
        CountryEnum[CountryEnum["Europe"] = 4] = "Europe";
        CountryEnum[CountryEnum["Asia"] = 5] = "Asia";
    })(CountryEnum = Vehicle.CountryEnum || (Vehicle.CountryEnum = {}));
    let ConditionEnum;
    (function (ConditionEnum) {
        ConditionEnum[ConditionEnum["New"] = 1] = "New";
        ConditionEnum[ConditionEnum["Used"] = 2] = "Used";
        ConditionEnum[ConditionEnum["Certified"] = 3] = "Certified";
        ConditionEnum[ConditionEnum["Repairable"] = 4] = "Repairable";
    })(ConditionEnum = Vehicle.ConditionEnum || (Vehicle.ConditionEnum = {}));
    let SizeEnum;
    (function (SizeEnum) {
        SizeEnum[SizeEnum["Subcompact"] = 1] = "Subcompact";
        SizeEnum[SizeEnum["Compact"] = 2] = "Compact";
        SizeEnum[SizeEnum["MidSize"] = 3] = "MidSize";
        SizeEnum[SizeEnum["Large"] = 4] = "Large";
    })(SizeEnum = Vehicle.SizeEnum || (Vehicle.SizeEnum = {}));
})(Vehicle || (exports.Vehicle = Vehicle = {}));
